import { Page } from '@frontend/components';
import { useTranslation } from '@frontend/i18n';
import { useAppScopeSelection } from '@frontend/scope';
import { theme } from '@frontend/theme';
import { emptyStateGraphics } from '@frontend/design-system';

type NoScopeAccessProps = {
  scopeName?: string;
  dataTestId?: string;
};

const normalizeScopeName = (scopeName?: string) => {
  if (!scopeName) {
    return 'current';
  }

  return scopeName.replace(/[-_]/g, ' ');
};

export const NoScopeAccess = ({ scopeName, dataTestId = 'no-scope-access' }: NoScopeAccessProps) => {
  const { t } = useTranslation();
  const { selectedScope } = useAppScopeSelection();
  const EmptyStateGraphicFax = emptyStateGraphics.fax;

  const resolvedScopeName = normalizeScopeName(scopeName ?? selectedScope?.scopeType);

  return (
    <div data-testid={dataTestId}>
      <Page
        title={t('Not Accessible in current scope - {{scopeName}}', { scopeName: resolvedScopeName })}
        subtitle={t(
          'This page is unavailable while a {{scopeName}} scope is selected. Switch your location selection to access this page.',
          { scopeName: resolvedScopeName }
        )}
      >
        <EmptyStateGraphicFax css={{ maxHeight: 300, marginBottom: theme.spacing(4) }} />
      </Page>
    </div>
  );
};
